import { Component, ContentChildren, QueryList } from '@angular/core';
import { NarrowSidebarNavListItemDirective } from '../../directives/narrow-sidebar-nav-list-item.directive';

@Component({
  selector: 'app-narrow-sidebar-nav-list',
  imports: [],
  templateUrl: './narrow-sidebar-nav-list.component.html',
})
export class NarrowSidebarNavListComponent {
  @ContentChildren(NarrowSidebarNavListItemDirective) navItems?: QueryList<NarrowSidebarNavListItemDirective>;
}
